import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

export default function IncomeStatement() {
  const { apiFetch } = useAuth();
  const [report, setReport] = useState(null);

  useEffect(() => {
    apiFetch('/api/reports/income-statement').then(setReport).catch(() => {});
  }, []);

  const fmt = (n) => new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK' }).format(n);

  const downloadPdf = async () => {
    const token = localStorage.getItem('token');
    const API_BASE = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:3001';
    const res = await fetch(`${API_BASE}/api/reports/income-statement/pdf`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!res.ok) return;
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Resultatopgoerelse-${report?.fiscal_year?.name || ''}.pdf`;
    a.click();
    URL.revokeObjectURL(url);
  };

  if (!report) return <div className="loading">Indlæser...</div>;

  return (
    <div>
      <div className="page-header">
        <h1>Resultatopgørelse</h1>
        <div style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
          {report.fiscal_year && (
            <span style={{color: 'var(--gray-500)'}}>
              {report.fiscal_year.name} ({new Date(report.fiscal_year.start_date).toLocaleDateString('da-DK')} - {new Date(report.fiscal_year.end_date).toLocaleDateString('da-DK')})
            </span>
          )}
          <button className="btn btn-secondary" onClick={downloadPdf}>Download PDF</button>
        </div>
      </div>

      <div className="report-section">
        <h3>Indtægter</h3>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Konto</th>
                <th>Navn</th>
                <th className="text-right">Beløb</th>
              </tr>
            </thead>
            <tbody>
              {report.income.map(a => (
                <tr key={a.id}>
                  <td>{a.account_number}</td>
                  <td>{a.name}</td>
                  <td className="text-right amount">{fmt(a.balance)}</td>
                </tr>
              ))}
              <tr className="report-total">
                <td colSpan="2"><strong>Indtægter i alt</strong></td>
                <td className="text-right amount"><strong>{fmt(report.total_income)}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="report-section">
        <h3>Udgifter</h3>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Konto</th>
                <th>Navn</th>
                <th className="text-right">Beløb</th>
              </tr>
            </thead>
            <tbody>
              {report.expenses.map(a => (
                <tr key={a.id}>
                  <td>{a.account_number}</td>
                  <td>{a.name}</td>
                  <td className="text-right amount">{fmt(a.balance)}</td>
                </tr>
              ))}
              <tr className="report-total">
                <td colSpan="2"><strong>Udgifter i alt</strong></td>
                <td className="text-right amount"><strong>{fmt(report.total_expenses)}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className={`report-result ${report.result >= 0 ? 'amount-positive' : 'amount-negative'}`}>
        Årets resultat: {fmt(report.result)}
      </div>
    </div>
  );
}
